var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-snippet"},[_c('div',{staticClass:"d-flex justify-space-between"},[_c('h3',[_vm._v("Code Snippet")]),_c('v-btn',{staticClass:"rounded-lg",attrs:{"color":"white","elevation":"1"},on:{"click":_vm.copyCode}},[_vm._v("Copy Code")])],1),_c('div',{staticClass:"code"},[_vm._v(" "+_vm._s(_vm.code)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }